import { CoreApi, ProductInfoComponent } from '@inter-ikea-storageone/range';
import { ProductComponent, ComponentIds, Entity, HierarchyUtils } from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';

/**
 * If there's a support leg in the scene, return support leg product ref,
 * Else return the selected leg, i.e the regular leg
 */
export const supportLegSelection = (selectedEntity: Entity, coreApi: CoreApi) => {
  let supportLegs = coreApi.entities.getByProductType(ProductType.BESTA_SUPPORTING_LEG);
  let legEntity = selectedEntity;

  if (selectedEntity && selectedEntity.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
    const frameLegs = HierarchyUtils.descendants(selectedEntity).filter(child =>
      child.hasComponent(ComponentIds.LEG_COMPONENT_ID)
    );

    supportLegs = frameLegs.filter(
      leg =>
        leg.getComponent<ProductInfoComponent>(ProductInfoComponent.id)?.productType ===
        ProductType.BESTA_SUPPORTING_LEG
    );
    if (frameLegs.length > 0) {
      legEntity = frameLegs[0];
    }
  }

  if (supportLegs.length > 0) {
    const supportLegRef = supportLegs[0].getComponent<ProductComponent>(
      ComponentIds.PRODUCT_COMPONENT_ID
    )?.productRef;
    return supportLegRef ? [supportLegRef] : [];
  }

  const selectedRef = legEntity.getComponent<ProductComponent>(ComponentIds.PRODUCT_COMPONENT_ID)
    ?.productRef;
  return selectedRef ? [selectedRef] : [];
};
